import { ChipProps } from "@mui/material";
import i18n from "./i18n";

const colors: Record<string, ChipProps["color"]> = {
  DRAFT: "default", PENDING: "warning", OPEN: "warning", CREATED: "warning",
  LOADING: "warning", READY: "info",
  EXPECTED: "info", CUSTOMS_PENDING: "warning", ARRIVED: "warning", WAITING_TRANSFER: "warning",
  ASSIGNED: "info", RECEIVING: "info", POSTING: "info", PROCESSING: "info",
  IN_PROGRESS: "info", TRANSFERRED: "info", PROPOSED: "warning", ATP_AVAILABLE: "info",
  ALLOCATED: "success", RECEIVED: "success", COMPLETED: "success",
  COMPLETED_WITH_INCIDENT: "warning",
  CLOSED: "success", PUBLISHED: "success", ACTIVE: "success",
  EXCEPTION: "error", FAILED: "error", ATP_FAILED: "error",
  CANCELLED: "default", EXPIRED: "default", ARCHIVED: "default",
  "À TRAITER": "warning", "PROPOSÉE": "warning", "OUVERTE": "warning",
  "ATTENDUE": "info", "ARRIVÉE": "warning", "AFFECTÉE": "info",
  "EN COURS": "info", "EN RÉCEPTION": "info", "PRISE EN CHARGE": "info",
  "TERMINÉE": "success", TO_RESOLVE: "warning", PENDING_APPROVAL: "warning", REMEDIATION: "warning"
};

export function operationalStatusColor(status: string | null | undefined) {
  return colors[status ?? ""] ?? "default";
}

export function sentenceCaseLabel(value: string | null | undefined) {
  if (!value) return "";
  const locale = i18n.resolvedLanguage || i18n.language;
  const normalized = value.replaceAll("_", " ").trim().toLocaleLowerCase(locale);
  return normalized.charAt(0).toLocaleUpperCase(locale) + normalized.slice(1);
}

export function operationalStatusLabel(status: string | null | undefined) {
  if (!status) return "";
  const key = `status.${status}`;
  return sentenceCaseLabel(i18n.exists(key) ? i18n.t(key) : status);
}
